// src/components/filters/TypeFilter.tsx
import {
  Grid,
  Typography,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Box,
} from "@mui/material";
import { ArrowDown } from "@phosphor-icons/react";
import { ArrowUp } from "@phosphor-icons/react/dist/ssr";
import { useContext } from "react";
import { LanguageContext } from "../../globals/LanguageContext";
import { Filters } from "../../models/Filters";

type Type = "varia" | "inkomst" | "uitgave";

type Props = {
  filters: Filters;
  onChange: (val: any) => void;
};

const availableTypes: Type[] = ["varia", "inkomst", "uitgave"];

export function TypeFilter({ filters, onChange }: Props) {
  const { dictionary } = useContext(LanguageContext);

  const handleTypeChange = (val: string) => {
    onChange({ ...filters, type: val });
  };

  const toggleSortDirection = () => {
    const current = filters.sortDirection?.direction || "asc";
    onChange({
      ...filters,
      sortDirection: {
        key: "type",
        direction: current === "asc" ? "desc" : "asc",
      },
    });
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Box display="flex" alignItems="center">
          <Typography variant="subtitle1" sx={{ mr: 1 }}>
            {dictionary.filters.type}
          </Typography>
          <IconButton onClick={toggleSortDirection} size="small">
            {filters.sortDirection?.direction === "desc" ? (
              <ArrowDown fontSize="small" />
            ) : (
              <ArrowUp fontSize="small" />
            )}
          </IconButton>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <FormControl fullWidth>
          <Select
            value={filters.type}
            onChange={(e) => handleTypeChange(e.target.value)}
            displayEmpty
          >
            <MenuItem value="">
              <em>All Types</em>
            </MenuItem>
            {availableTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}
